import { createFileRoute } from "@tanstack/react-router";
import { i18nLinks, i18nOgMeta, localeUrl } from "@/lib/seo";
import { m } from "@/paraglide/messages";
import { MarkdownTablePage } from "@/tools/markdown-table/pages/MarkdownTablePage";

const PATH = "/markdown-table-generator";

export const Route = createFileRoute("/markdown-table-generator")({
  ssr: true,
  head: () => ({
    meta: [
      { title: m.mt_meta_title() },
      { name: "description", content: m.mt_meta_description() },
      { property: "og:title", content: m.mt_meta_title() },
      { property: "og:description", content: m.mt_meta_description() },
      ...i18nOgMeta(PATH),
    ],
    links: [...i18nLinks(PATH)],
    scripts: [
      {
        type: "application/ld+json",
        children: JSON.stringify({
          "@context": "https://schema.org",
          "@type": "BreadcrumbList",
          itemListElement: [
            {
              "@type": "ListItem",
              position: 1,
              name: m.mt_breadcrumb_home(),
              item: localeUrl(`/`),
            },
            {
              "@type": "ListItem",
              position: 2,
              name: m.mt_tool_name(),
              item: localeUrl(`${PATH}`),
            },
          ],
        }),
      },
      {
        type: "application/ld+json",
        children: JSON.stringify({
          "@context": "https://schema.org",
          "@type": "FAQPage",
          mainEntity: [
            {
              "@type": "Question",
              name: m.mt_faq1_q(),
              acceptedAnswer: { "@type": "Answer", text: m.mt_faq1_a() },
            },
            {
              "@type": "Question",
              name: m.mt_faq2_q(),
              acceptedAnswer: { "@type": "Answer", text: m.mt_faq2_a() },
            },
            {
              "@type": "Question",
              name: m.mt_faq3_q(),
              acceptedAnswer: { "@type": "Answer", text: m.mt_faq3_a() },
            },
            {
              "@type": "Question",
              name: m.mt_faq4_q(),
              acceptedAnswer: { "@type": "Answer", text: m.mt_faq4_a() },
            },
          ],
        }),
      },
    ],
  }),
  component: MarkdownTablePage,
});
